import { useContext } from 'react'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { AuthContext, isPlatformUser } from '@retink/web-auth'
import { Badge, ErrorState, LoadingState, statusTone, useResource } from '@retink/web-ui'
import { api } from '../lib/api'

interface Organization { id: string; name: string; status: string }

export function OrganizationFrame() {
  const { user } = useContext(AuthContext)
  const { orgId } = useParams<{ orgId: string }>()
  const platform = isPlatformUser(user)
  const allowed = platform || (user?.orgRole === 'admin' && user.orgId === orgId)
  const { data: organization, loading, error, reload } = useResource(
    () => api.get<Organization>(`/api/orgs/${orgId}`),
    [orgId],
  )

  if (!allowed) return <Navigate to="/" replace />
  if (loading) return <div className="p-8"><LoadingState /></div>
  if (error || !organization) return <div className="p-8"><ErrorState message={error ?? 'Organization not found'} onRetry={reload} /></div>

  return (
    <div className="min-h-full">
      <div className="border-b border-border bg-card">
        <div className="mx-auto max-w-7xl px-5 py-5">
          <div className="flex items-center gap-3">
            <h1 className="text-xl font-semibold text-foreground">{organization.name}</h1>
            <Badge tone={statusTone(organization.status)}>{organization.status}</Badge>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl"><Outlet context={{ orgId, orgName: organization.name }} /></div>
    </div>
  )
}
